import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import CustomChartTooltip from './CustomChartTooltip';

const TransporterBarChart = ({ data }) => {
    const isEmpty = !data || data.length === 0;

    return (
        <div style={{ width: '100%', height: 500, position: 'relative', overflow: 'hidden' }}>
            {/* Subtle Glow Backgrounds */}
            <div className="pointer-events-none absolute inset-0" style={{ zIndex: 0 }}>
                <div style={{
                    position: 'absolute',
                    left: '10%',
                    top: '20%',
                    width: '150px',
                    height: '150px',
                    background: 'rgba(168, 85, 247, 0.15)',
                    borderRadius: '50%',
                    filter: 'blur(60px)'
                }} />
                <div style={{
                    position: 'absolute',
                    right: '10%',
                    bottom: '10%',
                    width: '150px',
                    height: '150px',
                    background: 'rgba(59, 130, 246, 0.15)',
                    borderRadius: '50%',
                    filter: 'blur(60px)'
                }} />
            </div>

            <div style={{ position: 'relative', zIndex: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ margin: '0 0 20px 0', fontSize: '1.25em', fontWeight: 'var(--font-bold)', color: 'var(--text-primary)', letterSpacing: '0.5px' }}>
                    Nakliye Firması Performansı
                </h3>

                <div style={{ flex: 1, minHeight: 0 }}>
                    {isEmpty ? (
                        <div className="flex items-center justify-center h-full text-secondary italic opacity-60">
                            Veri Yok
                        </div>
                    ) : (
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                                data={data}
                                layout="vertical"
                                margin={{ top: 5, right: 30, left: 40, bottom: 20 }}
                                barGap={8}
                            >
                                <defs>
                                    <linearGradient id="barGradientOnTime" x1="0" y1="0" x2="1" y2="0">
                                        <stop offset="0%" stopColor="#06B6D4" stopOpacity={0.8} />
                                        <stop offset="100%" stopColor="#3B82F6" stopOpacity={0.9} />
                                    </linearGradient>
                                    <linearGradient id="barGradientWaiting" x1="0" y1="0" x2="1" y2="0">
                                        <stop offset="0%" stopColor="#8B5CF6" stopOpacity={0.7} />
                                        <stop offset="100%" stopColor="#A855F7" stopOpacity={0.8} />
                                    </linearGradient>
                                    <linearGradient id="barGradientDelayed" x1="0" y1="0" x2="1" y2="0">
                                        <stop offset="0%" stopColor="#EF4444" stopOpacity={0.7} />
                                        <stop offset="100%" stopColor="#F87171" stopOpacity={0.8} />
                                    </linearGradient>
                                </defs>

                                <CartesianGrid
                                    strokeDasharray="3 3"
                                    stroke="var(--border-color)"
                                    horizontal={true}
                                    vertical={true}
                                    strokeOpacity={0.8}
                                />

                                <XAxis
                                    type="number"
                                    stroke="var(--text-secondary)"
                                    tick={{ fill: 'var(--text-secondary)', fontSize: 12 }}
                                    axisLine={{ stroke: 'var(--border-color)', strokeWidth: 1.5 }}
                                    tickLine={{ stroke: 'var(--border-color)', strokeWidth: 1.5 }}
                                    domain={[0, 'dataMax + 1']}
                                    allowDecimals={false}
                                />

                                <YAxis
                                    type="category"
                                    dataKey="name"
                                    stroke="var(--text-secondary)"
                                    width={120}
                                    tick={{ fill: 'var(--text-primary)', fontSize: 12, fontWeight: 700 }}
                                    axisLine={{ stroke: 'var(--border-color)', strokeWidth: 1.5 }}
                                    tickLine={{ stroke: 'var(--border-color)', strokeWidth: 1.5 }}
                                />

                                <Tooltip
                                    cursor={{ fill: 'var(--bg-hover)', opacity: 0.3, radius: 10 }}
                                    content={<CustomChartTooltip />}
                                    wrapperStyle={{ zIndex: 100 }}
                                />

                                <Legend
                                    verticalAlign="bottom"
                                    align="center"
                                    wrapperStyle={{ paddingTop: '20px' }}
                                    iconType="circle"
                                    formatter={(value) => (
                                        <span style={{ color: 'var(--text-secondary)', fontSize: '13px', marginLeft: '5px', fontWeight: 600 }}>{value}</span>
                                    )}
                                />

                                <Bar
                                    dataKey="onTime"
                                    name="Zamanında"
                                    stackId="a"
                                    fill="url(#barGradientOnTime)"
                                    barSize={32}
                                    stroke="rgba(255,255,255,0.1)"
                                    strokeWidth={1}
                                    activeBar={{
                                        stroke: '#06B6D4',
                                        strokeWidth: 2,
                                        filter: 'brightness(1.3) drop-shadow(0 0 5px #06B6D4)'
                                    }}
                                />
                                <Bar
                                    dataKey="waiting"
                                    name="Bekleyen"
                                    stackId="a"
                                    fill="url(#barGradientWaiting)"
                                    barSize={32}
                                    stroke="rgba(255,255,255,0.1)"
                                    strokeWidth={1}
                                    activeBar={{
                                        stroke: '#8B5CF6',
                                        strokeWidth: 2,
                                        filter: 'brightness(1.3) drop-shadow(0 0 5px #8B5CF6)'
                                    }}
                                />
                                <Bar
                                    dataKey="delayed"
                                    name="Geciken"
                                    stackId="a"
                                    fill="url(#barGradientDelayed)"
                                    radius={[0, 12, 12, 0]}
                                    barSize={32}
                                    stroke="rgba(255,255,255,0.1)"
                                    strokeWidth={1}
                                    activeBar={{
                                        stroke: 'var(--status-delayed)',
                                        strokeWidth: 2,
                                        filter: 'brightness(1.3) drop-shadow(0 0 5px var(--status-delayed))'
                                    }}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TransporterBarChart;
